/**
 * サイドバーにカレント表示を付ける関数
 */
export const sidebardInit = () => {
    const sideParent = document.querySelector(".Sidebard__innerSide");
    const side = document.querySelector(".Sidebard__innerSide ul");
    const progressScroll = document.querySelector(".Sidebard__innerProgress");
    const progressSide = document.querySelector(".Sidebard__innerProgress ul");
    const Sidebard__innerProgress = document.querySelector(
        ".Sidebard__innerProgress"
    );

    if (side && !side.parentNode.parentNode.classList.contains("noCrnt")) {
        try {
            const pt = document.querySelector(".Pagetop");
            pt.classList.add("hasSidebar");
        } catch (error) {
            // エラー処理
        }

        // カレント表示
        const lis = side.querySelectorAll("li"),
            plis = progressSide ? progressSide.querySelectorAll("li") : null,
            cnts = document.querySelectorAll(
                ".Sidebard__innerCntInner [id]:not(.noAnchor)"
            );

        setTimeout(() => {
            scroll();
        }, 500);

        window.addEventListener("scroll", scroll);
        const num = {
            prev: 0,
        };

        function scroll() {
            let currentIndex = -1;

            const line =
                innerWidth > 1024
                    ? sideParent.getBoundingClientRect().bottom
                    : innerHeight * 0.5;

            // セクションを上から見る
            for (let i = 0; i < cnts.length; i++) {
                const cnt = cnts[i];
                const cntPos = cnt.getBoundingClientRect();
                if (cntPos.top <= line + 1) {
                    currentIndex = i;
                } else {
                    break;
                }
            }

            // カレント表示の更新
            if (currentIndex !== -1) {
                lis.forEach((li, index) => {
                    if (index === currentIndex) {
                        li.classList.add("is-crnt");
                        try {
                            plis[index].classList.add("is-crnt");
                        } catch (error) {}
                    } else {
                        li.classList.remove("is-crnt");
                        try {
                            plis[index].classList.remove("is-crnt");
                        } catch (error) {}
                    }
                });

                if (num.prev !== currentIndex) {
                    num.prev = currentIndex;
                    try {
                        const pliInfo =
                            plis[currentIndex].getBoundingClientRect();
                        const pos =
                            pliInfo.left + pliInfo.width / 2 - innerWidth / 2;

                        const maxScroll =
                            progressScroll.scrollWidth -
                            progressScroll.clientWidth -
                            progressScroll.scrollLeft;

                        // スクロール位置を制限
                        const clampedPos = Math.max(
                            progressScroll.scrollLeft * -1,
                            Math.min(pos, maxScroll)
                        );

                        progressScroll.scrollBy({
                            left: clampedPos,
                            behavior: "smooth",
                        });
                    } catch (error) {
                        // エラー処理
                    }
                }
            }
        }

        let to = null;

        lis.forEach((li, index) => {
            li.querySelector("a").addEventListener("mouseenter", () => {
                clearTimeout(to);
                lis.forEach((li, index) => {
                    li.classList.remove("crnt");
                });
            });
            li.querySelector("a").addEventListener("mouseleave", () => {
                to = setTimeout(() => {
                    scroll();
                }, 500);
            });
        });
    }

    const windowScroll = () => {
        if (Sidebard__innerProgress) {
            Sidebard__innerProgress.classList.remove("is-hidden");
        }
    };

    // スクロールイベントリスナーを追加
    window.addEventListener("scroll", windowScroll);

    return () => {
        window.removeEventListener("scroll", windowScroll);
    };
};

sidebardInit();
